<template>
  <div class="pageMyReservationInfo">
    <el-row>
      <el-col :span="6">
        <h2>
          {{ $t("pages.wording.reserve") }}
          <el-tooltip :content="$t('pages.wording.genQRCode')" placement="right" effect="light">
            <img class="min-qrcode" src="../assets/img/qr-code-icon.png" @click="openQRCodeDialog()" />
          </el-tooltip>
        </h2>
      </el-col>
      <el-col :span="18">
        <div v-if="parent" class="buttons c-form">
          <el-button class="blue-button button-right" @click="back" type="primary">{{
            $t("pages.button.back")
          }}</el-button
          ><!--關閉-->
        </div>
      </el-col>
    </el-row>

    <el-form label-width="120px">
      <el-collapse v-model="activeShowBlock">
        <el-collapse-item class="collapsecontent" name="basic">
          <template slot="title">
            <h3>{{ $t("pages.wording.basisInfo") }}</h3>
            <!--基本資訊-->
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveNo')" prop="reserveNo"
                  ><!--單號-->
                  <el-input :disabled="true" :value="reserveItems.reserveNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactName')" prop="deltaContactName"
                  ><!--台達接洽人-->
                  <el-input :disabled="true" :value="reserveItems.deltaContactName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applyDate')" prop="applyDate"
                  ><!--預約日期-->
                  <el-input :disabled="true" :value="reserveItems.applyDate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactNumber')" prop="deltaContactNumber"
                  ><!--接洽人電話-->
                  <el-input :disabled="true" :value="reserveItems.deltaContactNumber"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applicatorName')" prop="applicatorName"
                  ><!--填單人-->
                  <el-input :disabled="true" :value="reserveItems.applicatorName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactMail')" prop="deltaContactMail"
                  ><!--接洽人Mail-->
                  <el-input :disabled="true" :value="reserveItems.deltaContactMail"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="reserve">
          <template slot="title">
            <h3>{{ $t("pages.wording.containForm") }}</h3>
            <!--填單內容-->
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.oaCode')" prop="OACode"
                  ><!--OA Code-->
                  <el-input :disabled="true" :value="reserveItems.OACode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveRegion')" prop="reserveRegion"
                  ><!--抵達地區-->
                  <el-input :disabled="true" :value="reserveItems.reserveRegion"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendor')" prop="vendor"
                  ><!--公司名稱-->
                  <el-input :disabled="true" :value="reserveItems.vendor"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArea')" prop="reserveArea"
                  ><!--抵達廠區-->
                  <el-input :disabled="true" :value="reserveItems.reserveArea"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactName')" prop="vendorContactName"
                  ><!--廠商聯絡人-->
                  <el-input :disabled="true" :value="reserveItems.vendorContactName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveFactory')" prop="reserveFactory"
                  ><!--抵達廠別-->
                  <el-input :disabled="true" :value="reserveItems.reserveFactory"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactListNumber')" prop="vendorContactNumber"
                  ><!--聯絡人電話-->
                  <el-input :disabled="true" :value="reserveItems.vendorContactNumber"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveLocation')" prop="reserveLocation"
                  ><!--抵達地點-->
                  <el-input
                    :disabled="true"
                    :value="$store.getters.getSysCodeText('location', reserveItems.reserveLocation)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactMail')" prop="vendorContactMail"
                  ><!--聯絡人Mail-->
                  <el-input :disabled="true" :value="reserveItems.vendorContactMail"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveDate')" prop="reserveArriveTimes"
                  ><!--預約抵達日期-->
                  <el-input :disabled="true" :value="reserveItems.reserveArriveTimes"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.enterReason')" prop="enterReason"
                  ><!--入廠事由-->
                  <el-input
                    :disabled="true"
                    :value="$store.getters.getSysCodeText('enterReason', reserveItems.enterReason)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain c-form-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="soTable" v-if="isGenerateByERP">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.releaseOrderInfo") }}</h3>
            </div>
          </template>
          <div class="boxContain c-form">
            <ReserveSOTable v-if="isGenerateByERP" :reserveID="reserveItems.id" :oaCode="reserveItems.OACode" />
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="carInfo" v-if="reserveItems.driverName != null">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.carListInfo") }}</h3>
              <!--車輛資訊-->
            </div>
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.driverName')" prop="driverName"
                  ><!--駕駛員姓名-->
                  <el-input :disabled="true" :value="reserveItems.driverName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.driverID')" prop="driverID"
                  ><!--司機ID-->
                  <el-input :disabled="true" :value="reserveItems.driverID"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carPlat')" prop="carlicensePlate"
                  ><!--車輛號牌-->
                  <el-input :disabled="true" :value="reserveItems.carlicensePlate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.driverPhone')" prop="driverPhone"
                  ><!--駕駛聯絡電話-->
                  <el-input :disabled="true" :value="reserveItems.driverPhone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carType')" prop="carType"
                  ><!--車輛類型-->
                  <el-input
                    :disabled="true"
                    :value="$store.getters.getSysCodeText('carType', reserveItems.carType)"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carColor')" prop="carColor"
                  ><!--車輛顏色-->
                  <el-input
                    :disabled="true"
                    :value="$store.getters.getSysCodeText('carColor', reserveItems.carColor)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="entourageInfo" v-if="entourageInfo.length > 0">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.entourageInfo") }}</h3>
              <!--隨行人資訊-->
            </div>
          </template>
          <div class="boxContain c-form">
            <ul class="boxSection list">
              <li v-for="(items, index) in entourageInfo" :key="index" :class="`entourageInfo-${index}`">
                <h4>{{ $t("pages.wording.entourage") }} {{ index + 1 }}</h4>
                <!--隨行人-->
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item :label="$t('pages.wording.entourageName')" prop="entourageName"
                      ><!--隨行人員姓名-->
                      <el-input :disabled="true" :value="items.entourageName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('pages.wording.entourageID')" prop="entourageID"
                      ><!--隨行人證號-->
                      <el-input :disabled="true" :value="items.entourageID"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </li>
            </ul>
            <!--boxSection-->
          </div>
          <!--boxContain-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="carringInfo" v-if="carringInfo.length > 0">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.carringInfo") }}</h3>
              <!--攜帶物資訊-->
            </div>
          </template>
          <div class="boxContain c-form">
            <ul class="boxSection list">
              <li v-for="(items, index) in carringInfo" :key="index" :class="`carryItemInfo-${index}`">
                <h4>{{ $t("pages.wording.carring") }} {{ index + 1 }}</h4>
                <!--攜帶物-->
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item :label="$t('pages.wording.carringType')" prop="carring"
                      ><!--攜帶物種類-->
                      <el-input
                        :disabled="true"
                        :value="$store.getters.getSysCodeText('carringType', items.carring)"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('pages.wording.carringNum')" prop="carringType"
                      ><!--攜帶物數量-->
                      <el-input :disabled="true" :value="items.carringType"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </li>
            </ul>
            <!--boxSection-->
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="inspectStatus">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.inspectStatus") }}</h3>
              <!--檢查狀態-->
            </div>
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.entering')" prop="entering"
                  ><!--進廠檢查-->
                  <el-input
                    :disabled="true"
                    :value="inspectItem.entering ? $t('reserve.status.' + inspectItem.entering) : ''"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.stayTime')" prop="stayTime"
                  ><!--停車時間-->
                  <el-input :disabled="true" :value="reserveItems.stayTime"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.in1')" prop="in1"
                  ><!--出廠初檢-->
                  <el-input
                    :disabled="true"
                    :value="inspectItem.in1 ? $t('reserve.status.' + inspectItem.in1) : ''"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.stayReason')" prop="stayReason"
                  ><!--停留原因-->
                  <el-input
                    :disabled="true"
                    :value="$store.getters.getSysCodeText('delayReason', reserveItems.stayReason)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.in2')" prop="in2"
                  ><!--出廠復檢-->
                  <el-input
                    :disabled="true"
                    :value="inspectItem.in2 ? $t('reserve.status.' + inspectItem.in2) : ''"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="buttons c-form">
        <el-button class="blue-button button-right" @click="cencelApplication" type="primary">{{
          $t("pages.button.close")
        }}</el-button
        ><!--關閉-->
      </div>
    </el-form>
    <el-dialog width="35%" :title="$t('pages.wording.genQRCode')" :visible.sync="showQRCode">
      <div slot="title" class="dialog-title">
        <h2>
          {{ $t("pages.wording.genQRCode") }}
        </h2>
      </div>
      <div class="qrcode-body" v-html="qrCodeHtml"></div>
      <article class="qrcode-hint">
        {{ $t("pages.wording.useQRCodeHint") }}
      </article>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import ReserveSOTable from "@/components/Reserve/ReserveSOTable"

export default {
  name: "PageMyReservationInfo",
  props: ["id", "parentName", "parent"],
  components: {
    ReserveSOTable,
  },
  data() {
    return {
      reserveInfo: {},
      carringInfo: [],
      entourageInfo: [],
      inspectInfo: {},
      reserveItems: {
        id: -1,
        reserveNo: "",
        deltaContactNT: "",
        applyDate: "",
        deltaContactNumber: "",
        applicatorName: "",
        deltaContactMail: "",
        deltaContactName: "",
        OACode: "",
        reserveRegion: "",
        vendor: "",
        reserveArea: "",
        vendorContactName: "",
        reserveFactory: "",
        vendorContactNumber: "",
        reserveLocation: "",
        vendorContactMail: "",
        reserveArriveTimes: "",
        enterReason: "",
        tempCar: "",
        driverName: "",
        driverID: "",
        carlicensePlate: "",
        driverPhone: "",
        carType: "",
        carColor: "",
        stayReason: "",
        stayTime: "",
      },
      inspectItem: {
        entering: "",
        in1: "",
        in2: "",
      },
      isGenerateByERP: false,
      activeShowBlock: ["basic", "reserve", "soTable", "carInfo", "entourageInfo", "carringInfo", "inspectStatus"],
      qrCodeHtml: null,
      showQRCode: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const id = this.$props.id === undefined ? this.$route.query.id : this.$props.id
      this.getReserveInfo(id)
    },
    getReserveInfo(id) {
      this.$store.dispatch("getReserveInfo", { params: { id: id } })
    },
    async getReserveQRCode() {
      try {
        const { data } = await api.apiGetReserveQRCode(this.reserveItems.reserveNo, this.reserveItems.id)
        this.qrCodeHtml = data
      } catch (error) {
        console.error(error)
      }
    },
    buildReserveInfo(data) {
      let tmpcar
      if (data.tempCar == true) tmpcar = true
      else tmpcar = false

      this.reserveInfo = data
      this.reserveItems.id = data.id
      this.reserveItems.reserveNo = data.reserveNo
      this.getReserveQRCode()
      this.reserveItems.reserveType = data.reserveType
      this.reserveItems.deltaContactName = data.deltaContactName
      this.reserveItems.applyDate = utils.getFormateDateTime("Date", data.applyDatetime)
      this.reserveItems.deltaContactNumber = data.deltaContactNumber
      this.reserveItems.applicatorName = data.applicatorName
      this.reserveItems.deltaContactMail = data.deltaContactMail
      this.reserveItems.OACode = data.OACode
      this.reserveItems.reserveRegion = data.reserveRegion
      this.reserveItems.vendor = data.vendor
      this.reserveItems.reserveArea = data.reserveArea
      this.reserveItems.vendorContactName = data.vendorContactName
      this.reserveItems.reserveFactory = data.reserveFactory
      this.reserveItems.vendorContactNumber = data.vendorContactNumber
      this.reserveItems.reserveLocation = data.reserveLocation
      this.reserveItems.vendorContactMail = data.vendorContactMail
      this.reserveItems.reserveArriveTimes = utils.getFormateDateTime("DateTime", data.reserveArriveDatetime)
      this.reserveItems.enterReason = data.enterReason
      this.reserveItems.stayTime = data.stayTime
      this.reserveItems.stayReason = data.stayReason

      this.reserveItems.driverName = !tmpcar ? data.driverName : data.tmpDriverName
      this.reserveItems.driverID = !tmpcar ? data.driverID : data.tmpDriverID
      this.reserveItems.carlicensePlate = !tmpcar ? data.carPlat : data.tmpCarPlat
      this.reserveItems.driverPhone = !tmpcar ? data.driverNumber : data.tmpDriverNumber
      this.reserveItems.carType = !tmpcar ? data.carType : data.tmpCarType
      this.reserveItems.carColor = !tmpcar ? data.carColor : data.tmpCarColor

      this.isGenerateByERP = this.reserveItems.reserveType === "ERP" || this.reserveItems.reserveType === "ERP_ONE"
    },
    buildCarringInfo(data) {
      this.carringInfo = data
    },
    buildEntourageInfo(data) {
      this.entourageInfo = data
    },
    buildInspectData(data) {
      this.inspectInfo = data
      this.inspectItem.entering = data.entering
      this.inspectItem.in1 = data.in1
      this.inspectItem.in2 = data.in2
    },
    openQRCodeDialog() {
      this.showQRCode = true
    },
    cencelApplication() {
      this.$router.push({ path: "/MyReservation" })
    },
    back() {
      const parent = this.$props.parentName
      const parameter = { back: true }

      if (parent == "searchReserve") {
        this.$router.push({
          name: "NewPageSearchReservation",
          params: parameter,
        })
      }
    },
  },
  watch: {
    "$store.getters.reserveInfo": function (datas) {
      const reserveData = datas.result
      this.buildReserveInfo(reserveData.reserveData)
      this.buildCarringInfo(reserveData.carringData)
      this.buildEntourageInfo(reserveData.entourageData)
      this.buildInspectData(reserveData.inspectData)
    },
  },
}
</script>

<style>
.c-form.boxContain {
  background-color: #fff;
  padding: 25px 25px 5px 25px;
  margin: 20px 0px;
  border-width: 0px 5px;
  border-style: solid;
  border-radius: 4px;
  border-color: #00a0e9;
}
.c-form .el-row {
  font-size: 16px;
  line-height: 50px;
  box-sizing: border-box;
}
.c-form .el-form-item {
  font-size: 14px;
}
.reserveLogTable th {
  background-color: #00a0e9;
  color: #fff;
}
</style>
